/* Paola & Joy — shop the room hotspots */
(function () {
  function init(root) {
    if (root.dataset.pjRoomReady === 'true') return;
    root.dataset.pjRoomReady = 'true';

    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-pj-room-marker]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pj-room-card]'));

    function closeAll(except) {
      markers.forEach(function (m) {
        if (m.dataset.pjRoomMarker !== except) m.setAttribute('aria-expanded', 'false');
      });
      cards.forEach(function (c) {
        if (c.dataset.pjRoomCard !== except) c.setAttribute('data-open', 'false');
      });
    }

    markers.forEach(function (m) {
      m.addEventListener('click', function (e) {
        e.stopPropagation();
        var id = m.dataset.pjRoomMarker;
        var card = root.querySelector('[data-pj-room-card="' + id + '"]');
        var open = m.getAttribute('aria-expanded') === 'true';
        closeAll(id);
        m.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (card) card.setAttribute('data-open', open ? 'false' : 'true');
      });
    });

    cards.forEach(function (c) { c.addEventListener('click', function (e) { e.stopPropagation(); }); });
    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  function boot() { document.querySelectorAll('[data-pj-room]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
